import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@app/classes';
import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { AuthService } from '@app/services';
import { ApplicantInterviewQuestionTypes } from '../../enums/applicant-interview-question-types.enum';

@Component({
    selector: 'app-applicant-interview-feedback-results',
    templateUrl: './applicant-interview-feedback-results.html',
    styleUrls: ['./applicant-interview-feedback-results.style.scss'],
})
export class ApplicantInterviewFeedbackResultsComponent implements OnInit {
    @Input() interviewQuestionsWithFeedbackResults: InterviewQuestion[] = [];
    @Input() applicantInterviewers: ApplicantInterviewers[] = [];
    applicantInterviewQuestionTypes = ApplicantInterviewQuestionTypes;
    allApplicantInterviewersSubmitted = false;
    someApplicantInterviewersSubmitted = false;
    hasRecruiterAccess = false;

    constructor(private auth: AuthService) {}

    ngOnInit(): void {
        this.hasRecruiterAccess = this.auth.can(Platform.recruiting.permission.recruiter);

        this.someApplicantInterviewersSubmitted = !!this.applicantInterviewers.filter(
            (applicantInterviewer) => applicantInterviewer.isSubmitted
        ).length;

        this.allApplicantInterviewersSubmitted =
            this.applicantInterviewers.filter((applicantInterviewer) => applicantInterviewer.isSubmitted).length ===
            this.applicantInterviewers.length;
    }
}
